module.exports = __webpack_public_path__ + "static/services3-f5682b8d3e143f73bf62759f9b55c6f2.jpg";